import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface BulkUpdateConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (email: string) => void;
  defaultEmail: string;
  updateCount: number;
  priceType: 'selling' | 'base';
}

export const BulkUpdateConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  defaultEmail,
  updateCount,
  priceType,
}: BulkUpdateConfirmDialogProps) => {
  const [email, setEmail] = useState(defaultEmail);

  useEffect(() => {
    if (open) {
      setEmail(defaultEmail || '');
    }
  }, [open, defaultEmail]);

  const priceLabel = priceType === 'selling' ? 'selling' : 'base';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm bulk update</DialogTitle>
          <DialogDescription>
            This will update {updateCount} product {priceLabel} prices asynchronously. You will
            receive an email when the update is complete.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="bulk-update-email">Notification email</Label>
            <Input
              id="bulk-update-email"
              type="email"
              value={email}
              onChange={event => setEmail(event.target.value)}
              placeholder="you@example.com"
            />
            <p className="text-sm text-muted-foreground">
              Results will be sent to this email address.
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" type="button" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button type="button" onClick={() => onConfirm(email)} disabled={!email}>
            Proceed with update
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
